import isBefore from 'date-fns/isBefore'
import parseISO from 'date-fns/parseISO'

import type {NormalizedBuild} from '../../../../../../types'

export const sortByFinishDate = (buildA: NormalizedBuild, buildB: NormalizedBuild): number => {
  const finishedDateA = buildA.finishDate != null ? parseISO(buildA.finishDate) : null
  const finishedDateB = buildB.finishDate != null ? parseISO(buildB.finishDate) : null

  if (finishedDateA == null || finishedDateB == null) {
    return 0
  }

  if (isBefore(finishedDateA, finishedDateB)) {
    return 1
  }

  if (isBefore(finishedDateB, finishedDateA)) {
    return -1
  }

  return 0
}
